// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector) // Detect user's language from browser/localStorage
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ha', 'yo', 'ig', 'ff', 'nu'], // Add all your supported languages here
    backend: {
      loadPath: '/locales/{{lng}}/translation.json' // Load from public/locales/...
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false // React already escapes
    }
  });

export default i18n;
